import React from 'react';

const Footer = () => {
  return (
    <>
              <div id="footer" className="fixed-bottom footer-top">
            <div className="container text-center">
                <div className="footer">
                    <p> &copy; 2021 Lara Foster | made with <i class="fab fa-react"></i> React</p>
                </div>
            </div>
        </div>
    </>
  );
}
export default Footer;
